import { render, staticRenderFns } from "./portworx-volume.vue?vue&type=template&id=67818cf6&"
import script from "./portworx-volume.vue?vue&type=script&lang=js&"
export * from "./portworx-volume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports